// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/resale/v1/legacy_portal_service.proto (package spwn.resale.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { LegacyPortalResaleApplication, LegacyPortalResaleApplicationStatus, LegacyPortalResaleListing, LegacyPortalResaleListingStatus, LegacyPortalResaleRound } from "./legacy_portal_common_pb";
/**
 * リセール回・受付状況一覧取得 API（イベントページ、出品・申込共通）
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetResaleRoundsRequest
 */
export class LegacyPortalResaleServiceGetResaleRoundsRequest extends Message {
    constructor(data) {
        super();
        /**
         * 対象イベントのイベントFirestoreID（必須）
         *
         * @generated from field: string event_firestore_id = 1;
         */
        this.eventFirestoreId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleServiceGetResaleRoundsRequest, a, b);
    }
}
LegacyPortalResaleServiceGetResaleRoundsRequest.runtime = proto3;
LegacyPortalResaleServiceGetResaleRoundsRequest.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetResaleRoundsRequest";
LegacyPortalResaleServiceGetResaleRoundsRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "event_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetResaleRoundsResponse
 */
export class LegacyPortalResaleServiceGetResaleRoundsResponse extends Message {
    constructor(data) {
        super();
        /**
         * その回に含まれる全対象券種が tickets に入った Round リスト（application / listings は空）
         *
         * @generated from field: repeated spwn.resale.v1.LegacyPortalResaleRound resale_rounds = 1;
         */
        this.resaleRounds = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleServiceGetResaleRoundsResponse, a, b);
    }
}
LegacyPortalResaleServiceGetResaleRoundsResponse.runtime = proto3;
LegacyPortalResaleServiceGetResaleRoundsResponse.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetResaleRoundsResponse";
LegacyPortalResaleServiceGetResaleRoundsResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "resale_rounds", kind: "message", T: LegacyPortalResaleRound, repeated: true },
]);
/**
 * リセール出品更新 API（出品登録・増減・取り下げを一括処理）
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleListingRequest
 */
export class LegacyPortalResaleServiceUpdateResaleListingRequest extends Message {
    constructor(data) {
        super();
        /**
         * リセール対象券種ID
         *
         * @generated from field: string resale_round_ticket_id = 1;
         */
        this.resaleRoundTicketId = "";
        /**
         * 出品希望枚数（0を指定した場合は出品取り下げ）
         *
         * @generated from field: int32 quantity = 2;
         */
        this.quantity = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceUpdateResaleListingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceUpdateResaleListingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceUpdateResaleListingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleServiceUpdateResaleListingRequest, a, b);
    }
}
LegacyPortalResaleServiceUpdateResaleListingRequest.runtime = proto3;
LegacyPortalResaleServiceUpdateResaleListingRequest.typeName = "spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleListingRequest";
LegacyPortalResaleServiceUpdateResaleListingRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "resale_round_ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleListingResponse
 */
export class LegacyPortalResaleServiceUpdateResaleListingResponse extends Message {
    constructor(data) {
        super();
        /**
         * 更新後の出品リスト
         *
         * @generated from field: repeated spwn.resale.v1.LegacyPortalResaleListing listings = 1;
         */
        this.listings = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceUpdateResaleListingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceUpdateResaleListingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceUpdateResaleListingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleServiceUpdateResaleListingResponse, a, b);
    }
}
LegacyPortalResaleServiceUpdateResaleListingResponse.runtime = proto3;
LegacyPortalResaleServiceUpdateResaleListingResponse.typeName = "spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleListingResponse";
LegacyPortalResaleServiceUpdateResaleListingResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "listings", kind: "message", T: LegacyPortalResaleListing, repeated: true },
]);
/**
 * 自身の出品状況・一覧取得 API
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleListingsRequest
 */
export class LegacyPortalResaleServiceGetMyResaleListingsRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleServiceGetMyResaleListingsRequest, a, b);
    }
}
LegacyPortalResaleServiceGetMyResaleListingsRequest.runtime = proto3;
LegacyPortalResaleServiceGetMyResaleListingsRequest.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleListingsRequest";
LegacyPortalResaleServiceGetMyResaleListingsRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "event_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "ticket_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(LegacyPortalResaleListingStatus), opt: true },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleListingsResponse
 */
export class LegacyPortalResaleServiceGetMyResaleListingsResponse extends Message {
    constructor(data) {
        super();
        /**
         * 自身が出品している券種（tickets[].listings）のみを含む Round リスト
         *
         * @generated from field: repeated spwn.resale.v1.LegacyPortalResaleRound resale_rounds = 1;
         */
        this.resaleRounds = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleServiceGetMyResaleListingsResponse, a, b);
    }
}
LegacyPortalResaleServiceGetMyResaleListingsResponse.runtime = proto3;
LegacyPortalResaleServiceGetMyResaleListingsResponse.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleListingsResponse";
LegacyPortalResaleServiceGetMyResaleListingsResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "resale_rounds", kind: "message", T: LegacyPortalResaleRound, repeated: true },
]);
/**
 * 自身の申込状況・一覧取得 API
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleApplicationsRequest
 */
export class LegacyPortalResaleServiceGetMyResaleApplicationsRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleServiceGetMyResaleApplicationsRequest, a, b);
    }
}
LegacyPortalResaleServiceGetMyResaleApplicationsRequest.runtime = proto3;
LegacyPortalResaleServiceGetMyResaleApplicationsRequest.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleApplicationsRequest";
LegacyPortalResaleServiceGetMyResaleApplicationsRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "event_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "ticket_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(LegacyPortalResaleApplicationStatus), opt: true },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleApplicationsResponse
 */
export class LegacyPortalResaleServiceGetMyResaleApplicationsResponse extends Message {
    constructor(data) {
        super();
        /**
         * 自身が申込している券種（tickets[].application）のみを含む Round リスト
         *
         * @generated from field: repeated spwn.resale.v1.LegacyPortalResaleRound resale_rounds = 1;
         */
        this.resaleRounds = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleServiceGetMyResaleApplicationsResponse, a, b);
    }
}
LegacyPortalResaleServiceGetMyResaleApplicationsResponse.runtime = proto3;
LegacyPortalResaleServiceGetMyResaleApplicationsResponse.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleApplicationsResponse";
LegacyPortalResaleServiceGetMyResaleApplicationsResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "resale_rounds", kind: "message", T: LegacyPortalResaleRound, repeated: true },
]);
/**
 * リセール申込更新 API（新規申込・枚数増減・取り下げを一括処理）
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleApplicationRequest
 */
export class LegacyPortalResaleServiceUpdateResaleApplicationRequest extends Message {
    constructor(data) {
        super();
        /**
         * リセール対象券種ID
         *
         * @generated from field: string resale_round_ticket_id = 1;
         */
        this.resaleRoundTicketId = "";
        /**
         * 申込希望枚数（0を指定した場合は申込取り下げ）
         *
         * @generated from field: int32 quantity = 2;
         */
        this.quantity = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceUpdateResaleApplicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceUpdateResaleApplicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceUpdateResaleApplicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleServiceUpdateResaleApplicationRequest, a, b);
    }
}
LegacyPortalResaleServiceUpdateResaleApplicationRequest.runtime = proto3;
LegacyPortalResaleServiceUpdateResaleApplicationRequest.typeName = "spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleApplicationRequest";
LegacyPortalResaleServiceUpdateResaleApplicationRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "resale_round_ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleApplicationResponse
 */
export class LegacyPortalResaleServiceUpdateResaleApplicationResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceUpdateResaleApplicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceUpdateResaleApplicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceUpdateResaleApplicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleServiceUpdateResaleApplicationResponse, a, b);
    }
}
LegacyPortalResaleServiceUpdateResaleApplicationResponse.runtime = proto3;
LegacyPortalResaleServiceUpdateResaleApplicationResponse.typeName = "spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleApplicationResponse";
LegacyPortalResaleServiceUpdateResaleApplicationResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "application", kind: "message", T: LegacyPortalResaleApplication, opt: true },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map